export default "__VITE_PUBLIC_ASSET__a42786e2__"